export const timestampFormat = 'YYMMDDHHmmssSS';
export const datetimestampFormat = 'YYMMMMDoHHmmssSS';
export const storeDateFormat = 'YYMMDD';
export const displayDateFormat = 'MM/DD/YY';
export const displayHourFormat = 'h:mm A';
export const displayFullDateMonthFormat = 'MMMM Do';
export const defaultTimezone = 'US/Pacific';

export const ooV2Url =
  process.env.REACT_APP_STAGE === 'production'
    ? 'https://order2.kiolyn.com'
    : 'https://order2-staging.kiolyn.com';
